const style = {
  display: "flex",
  flexDirection: "column",
  gap: 10
};

export function SettingsContainer(props) {
  return (<>
    <div style={{ ...style, gridArea: props.gridArea }}>{ props.children }</div>
  </>);
}
